import React, {useEffect, useState} from 'react';
import './BlackList.css';
import ConfirmationDialog from '../../../my-history/ConfirmationDialog'
import Translate, {t} from "../../../../../../components/Translate";
import {deleteUserFromBlackList, getCompanyBlackList} from "../../../../../../services/company/api";
import {addNotification as addNotificationAction} from "../../../../../../services/notification/action";
import {connect} from "react-redux";
import config from "../../../../../../config";
import PropTypes from "prop-types";
import {
    clearSelectedConversation as clearSelectedConversationFromStore,
    loadOlderMessagesRequested,
    selectConversationRequested
} from "../../../../../../services/chat/action";
import {confirmActionRequested} from "../../../../../../services/confirmAction/action";
import Modal from "react-modal";
import SelectedConversationHistory, {generalStyles} from "../../history/ConversationHistory";
import ShowChatIcon from "../../../../../../assets/ShowChatIcon";
import PlatformIcon from "../../../../../../components-new/PlatformIcon";
import Tooltip from "../../../../../../components-new/Tooltip";

function BlackList({
                      user,
                      client,
                      addNotification,
                      loadOlderMessages,
                      selectConversation,
                      clearSelectedConversationFromStore,
                      conversation,
                  }) {

    const [blacklistedUsers, setBlacklistedUsers] = useState([]);

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);


    useEffect(() => {
        getCompanyBlackList(client.id).then(data => {
            setBlacklistedUsers(data)
        })
    }, [client.id]);

    const openConfirmationDialog = (user) => {
        setUserToDelete(user);
        setIsDialogOpen(true);
    };

    const closeConfirmationDialog = () => {
        setIsDialogOpen(false);
        setUserToDelete(null);
    };

    const confirmDelete = () => {
        setBlacklistedUsers(blacklistedUsers.filter(user => user.id !== userToDelete.id));
        closeConfirmationDialog();
        deleteUserFromBlackList(userToDelete.id, client.id)
        addNotification('userDeletedFromList', config.notificationLevels.success);
    };

    const showConversationHistory = (conversationInfo) => {
        selectConversation({
            id: conversationInfo.id,
            companyId: conversationInfo.companyId,
            platform: conversationInfo.platform,
            userFirstName: conversationInfo.user.firstName,
            userLastName: conversationInfo.user.lastName,
            userThumbUrl: conversationInfo.user.thumbUrl,
        });
    };

    return (
        <div>
            <h3 className="blacklist-heading"><Translate text="blacklistedUsers"/></h3>
            <div className={'blacklist-block'}>
                <table className="custom-table">
                    <thead>
                    <tr className="table-head">
                        <th><Translate text={'id'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'name'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'platform'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'subject'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'description'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'ip'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'blockedBy'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'actions'}/></th>
                    </tr>
                    </thead>
                    <tbody>
                    {blacklistedUsers.map(bl => (
                        <tr key={bl.username}>
                            <td>{bl.id}</td>
                            <td style={{textAlign: 'center'}}>{bl.userName}</td>
                            <td style={{textAlign: 'center'}}>
                                <PlatformIcon conversation={bl.conversation} size={20}/>
                            </td>
                            <td style={{textAlign: 'center'}}>{bl.subject}</td>
                            <td style={{textAlign: 'center'}}>{bl.description}</td>
                            <td style={{textAlign: 'center'}}>{bl.userIp}</td>
                            <td style={{textAlign: 'center'}}>{bl.operatorName}</td>
                            <td style={{textAlign: 'center'}}>
                                <div style={{display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center'}}>

                                    <span style={{marginTop: '3px', cursor: 'pointer'}}
                                          onClick={() => showConversationHistory(bl.conversation)}>
                                        <ShowChatIcon
                                            style={{
                                                height: '21px',
                                                width: '21px',
                                            }}
                                        />
                                    </span>

                                    <Tooltip text={'remove'}>
                                        <button className="remove-btn" style={{fontSize: '22px'}}
                                                onClick={() => openConfirmationDialog(bl)}>
                                            ×
                                        </button>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <ConfirmationDialog
                isOpen={isDialogOpen}
                onClose={closeConfirmationDialog}
                onConfirm={confirmDelete}
                message={t({
                    text: 'sureDeleteUser',
                    user
                })}
            />

            <Modal
                closeTimeoutMS={config.closeTimeoutMS}
                style={generalStyles.modalStyles}
                isOpen={conversation.id}
                onRequestClose={clearSelectedConversationFromStore}
            >
                <SelectedConversationHistory
                    conversation={conversation}
                    user={user}
                    loadOlderMessages={loadOlderMessages}
                    closeWindow={clearSelectedConversationFromStore}
                    company={client}
                />
            </Modal>

        </div>
    );
}

BlackList.propTypes = {
    user: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    conversation: state.chat.conversation,
});

const mapDispatchToProps = (dispatch) => ({
    addNotification: addNotificationAction,

    selectConversation: (conversation) => {
        dispatch(selectConversationRequested(conversation));
    },
    loadOlderMessages: () => {
        dispatch(loadOlderMessagesRequested());
    },
    clearSelectedConversationFromStore: () => {
        dispatch(clearSelectedConversationFromStore());
    },
    confirmAction: (obj) => (dispatch(confirmActionRequested(obj.func, obj.args, obj.onCancel, obj.onCancelArgs, obj.content))),
});

export default connect(mapStateToProps, mapDispatchToProps)(BlackList);







// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/BlackList.jsx